export const bannerStyles = (background: string, width: number) => ({
  containerColumn: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: width > 1074 ? '95vh' : '100%',
    minHeight: '400px',
    margin: 0,
    backgroundColor: background,
  },
  containerRow: {
    paddingBottom:'60px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: '100%',
    height: '100%',
    minHeight: '400px',
    backgroundColor: background,
  },
  boxLeft: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '550px',
    minWidth: '550px',
    height: '55%',
    margin: 0,
    marginLeft: '80px',
    backgroundColor: background
  },
  boxRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: width > 970 ? 'center' : 'flex-end',
    justifyContent: width > 970 ? 'flex-end' : 'center',
    width: width > 970 ? '40%' : '100%',
    maxWidth: '619px',
    backgroundColor: background,
  },
  boxCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    margin: 0,
    backgroundColor: background,
  },
  background: {
    width: 'inherit',
    height: 'inherit',
    backgroundColor: background,
  },
  top: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'inherit',
    height: '10%',
    maxHeight: '170px',
    minHeight: '100px',
  },
  formContainer: {
    paddingTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: '25px',
    paddingRight: '50px',
    backgroundColor: '#FFFFFF',
    width: '90%',
    height: 'auto',
    maxHeight: '400px',
    borderRadius: '15px',
    marginTop: '40px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)'
  },
  container: {
    width: '90%',
    marginTop: '15px',
    paddingTop: '25px'
  },
  textField: {
    margin: '10px',
    width: '100%'
  },
  buttonField: {
    fontFamily: 'Open Sans',
    margin: '10px',
    width: '130px',
    height: '42px',
    paddingTop: '8px'
  },
  text: {
    fontFamily: 'Inter, sans-serif',
    fontSize: '11px',
    lineHeight: '1.1',
    fontWeight: 300,
    color: '#FFFFFF'
  },
  titleText: {
    fontFamily: 'Open Sans',
    fontSize: '27px',
    fontWeight: 700,
    color: '#FFFFFF'
  }
});
